// extracted by mini-css-extract-plugin
export default {"background":"ResourceLib_background__BS8yk","listContainer":"ResourceLib_listContainer__VgVfC"};